class AdminLatestNewsItem {
  constructor(
    _id,
    id,
    title,
    excerpt,
    date,
    category,
    imageURL,
    author,
    readTime,
    featured,
    active
  ) {
    this._id = _id;
    this.id = id;
    this.title = title;
    this.excerpt = excerpt;
    this.date = date;
    this.category = category;
    // keep both properties for compatibility (some code uses `image`, some `imageURL`)
    this.image = imageURL;
    this.author = author;
    this.readTime = readTime;
    this.featured = featured;
    this.active = active;
  }

  static fromJSON(json = {}) {
    // Accept API shapes with slightly different keys and provide sensible defaults
    // normalize/parse date values — if the API provides a timestamp or parseable string
    const rawDate = json.date || json.publishedAt || "";
    let parsedDate = "";
    if (rawDate) {
      // numeric timestamps (seconds or ms) should be handled; Date can parse ISO strings too
      const asNumber = Number(rawDate);
      if (!Number.isNaN(asNumber) && String(rawDate).trim() !== "") {
        // If the number looks like seconds (10 digits), convert to ms
        parsedDate = new Date(asNumber < 1e12 ? asNumber * 1000 : asNumber);
      } else {
        const dt = new Date(rawDate);
        parsedDate = isNaN(dt.getTime()) ? rawDate : dt;
      }
    }

    return new AdminLatestNewsItem(
      json._id || json.id || null,
      json.id || json._id || null,
      json.title || json.name || "",
      json.excerpt || json.summary || "",
      parsedDate,
      json.category || "",
      json.imageURL || json.image || null,
      json.author || "",
      json.readTime || json.read_time || "",
      !!json.featured,
      !!json.active
    );
  }

  toJSON() {
    return {
      _id: this._id,
      id: this.id,
      title: this.title,
      excerpt: this.excerpt,
      // emit date as ISO string when we have a Date instance, otherwise pass through
      date: this.date ? (this.date instanceof Date ? this.date.toISOString() : this.date) : "",
      category: this.category,
      imageURL: this.imageURL,
      author: this.author,
      readTime: this.readTime,
      featured: this.featured,
      active: this.active,
    };
  }
}

module.exports = AdminLatestNewsItem;
